import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
// import Loader from "../../../common/loader";
import CustomCkeditor from "../../../common/customeditor";
import * as faqServices from "../../../services/faq.services";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS, INPUT_LENGTH_500, INPUT_LENGTH_100, PLATFORM_TYPES } from "../../../../../utils/Constants";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const FAQEdit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);
  const [saveType, setSaveType] = useState("");
  const { t } = useTranslation()


  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard/1" },
    { title: t("link_faq"), url: "/admin/cms/faq/list/1" },
    { title: t("link_edit"), url: "" },
  ];


  useEffect(() => {
    faqServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data?.data ? data.data : []);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (<Formik
        enableReinitialize
        initialValues={{
          title: showdefault && showdefault.title ? showdefault.title : "",
          type: showdefault && showdefault.type ? showdefault.type : "website",
          description: showdefault && showdefault.description ? showdefault.description : "",
        }}
        validate={(values) => {
          const error = {};
          if (!values.title || !values.title.trim())
            error.title = "label_title_error";
          if (values.title.length > INPUT_LENGTH_100)
            error.title = "Title cannot be more than 100 characters long.";
          if (!values.description || !values.description.trim())
            error.description = "label_description_error";
          if (values.description.length > INPUT_LENGTH_500)
            error.description = "Description cannot be more than 500 characters long.";
          if (!values.type)
            error.type = "admin_err_platform_type_is_required";
          return error;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          globalLoader(true);
          let formData = new FormData();
          formData.append("o_id", params.id);
          formData.append("title", values.title);
          formData.append("description", values.description);
          formData.append("type", values.type);
          faqServices
            .Edit(formData)
            .then((response) => {
              setSubmitting(false);
              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: response.message,
                  ...SWAL_SETTINGS,
                });
                if (saveType !== "Save") {
                  setTimeout(() => {
                    resetForm({ values: "" });
                    globalLoader(false);
                    navigate(`/admin/cms/faq/list/1`);
                  }, 1000);
                }
                if (saveType === "Save") {
                  setTimeout(() => {
                    globalLoader(false);
                  }, 1000);
                }
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
                globalLoader(false);
              }
            })
            .catch((error) => {
              console.log("error ====> ", error);
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="row row-sm">
              <div className="col-lg-12 col-md-12 animation_fade">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="main-content-label mb-3">{t("edit_faq")}</h6>
                    </div>
                    {showdefault && Object.keys(showdefault).length > 0 ? (
                      <div className="row row-sm">

                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="type" className="text-left d-flex">
                            {t("label_platform")}:<span className="requirestar">*</span>
                          </label>
                          <select
                            name="type"
                            id="type"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.type}
                            className="form-control"
                          >
                            <option value="">{t("select_platform")}</option>
                            {PLATFORM_TYPES.map((platform) => (
                              <option key={platform.value} value={platform.value}>
                                {t(platform.label)}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger d-flex text-left">
                            {errors.type && touched.type && t(errors.type)}
                          </span>
                        </div>

                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("list_heading_title")}:<span className="requirestar">*</span>
                            {/* <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {t("tooltip_faq_title")}
                                </Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper> */}
                          </label>
                          <input
                            name="title"
                            id="title"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="form-control"
                            placeholder={t("faq_title_placeholder")}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.title && touched.title && t(errors.title)}
                          </span>
                        </div>

                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="description" className="text-left d-flex">
                            {t("label_description")}:<span className="requirestar">*</span>
                          </label>
                          <textarea
                            name="description"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.description}
                            className="form-control"
                            placeholder={t("faq_description_placeholder")}
                            rows="5"
                          />
                          {/* <CustomCkeditor
                            fieldname={"description"}
                            setFieldValue={setFieldValue}
                            value={values.description}
                            setFieldTouched={setFieldTouched}
                          /> */}
                          <span className="text-danger d-flex text-left">
                            {errors.description &&
                              touched.description &&
                              t(errors.description)}
                          </span>
                        </div>


                        <div className="">
                          <button
                            onClick={() => {
                              setSaveType("Save");
                            }}
                            className="btn btn-info mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save")}
                          </button>
                          <button
                            onClick={() => {
                              setSaveType("");
                            }}
                            className="btn btn-success mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save_exit")}
                          </button>
                          <button
                            className="btn ripple btn-secondary"
                            type="button"
                            onClick={() => navigate(-1)}
                          >
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <Loader />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
      ) : (
        <Loader />
      )}

    </>
  );
};

export default FAQEdit;
